import { RouteObject } from "react-router-dom";
import pathRoutes from "../../../routes/pathRoutes";
import Authenticated from "../../../utils/Authenticated";
import { MODES_OPTIONS } from "../../../types/generics.types";
import LayoutUncertainty from "../components/layouts/layout";
import Uncertainty from "../uncertainty";
import LayoutEditUncertainty from "../components/layouts/layoutEdit";
import EditUncertainty from "../editUncertainty";
import { PrivateRoutes } from "@app/utils/PrivateRoutes";
import { RolesTypes } from "@app/pages/users/utils/helpers";

const routesUncertainty: RouteObject = {
  path: pathRoutes.ADMIN_INCERTIDUMBRES,
  element: (
    <Authenticated>
      <LayoutUncertainty />
    </Authenticated>
  ),
  children: [
    {
      path: "",
      index: true,
      element: (
        <Authenticated>
          <Uncertainty />
        </Authenticated>
      ),
    },

    {
      path: "nuevo",
      element: <LayoutEditUncertainty />,
      children: [
        {
          index: true,
          element: (
            <PrivateRoutes
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <Authenticated>
                <EditUncertainty mode={MODES_OPTIONS.NEW} />
              </Authenticated>
            </PrivateRoutes>
          ),
        },
      ],
    },
    {
      path: "editar/:idUncertainty",
      element: <LayoutEditUncertainty />,
      children: [
        {
          index: true,
          element: (
            <PrivateRoutes
              permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
            >
              <Authenticated>
                <EditUncertainty mode={MODES_OPTIONS.EDIT} />
              </Authenticated>
            </PrivateRoutes>
          ),
        },
      ],
    },
    {
      path: "ver/:idUncertainty",
      element: <LayoutEditUncertainty />,
      children: [
        {
          index: true,
          element: (
            <Authenticated>
              <EditUncertainty mode={MODES_OPTIONS.VIEW} />
            </Authenticated>
          ),
        },
      ],
    },
  ],
};

export default routesUncertainty;
